import { createStore } from 'redux'

import reducer from './reducers'

export const getReduxStore = (reduxDevtoolsExtension) =>
  createStore(reducer, reduxDevtoolsExtension)

export default getReduxStore
